/// <reference path="../_references.ts"/>

module App.History {

	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import ServiceRequest = App.Customer.ServiceRequest;
	import Package = App.PriceGuide.Package;

	interface LocalStorage extends ng.local.storage.ILocalStorageService {
		selectedCustomerId: number;
	}

	export class HistoryService {
		public serviceRequestPhotos: ServiceRequestPhoto[];
		public selectedServiceRequest: ServiceRequest;

		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants,
			public SelectedAppointments: SelectedAppointment
		){
			SelectedAppointments.getAppointment().then(() => {
				this.initialize();
			});
		}

		initialize() {
			this.fetchServiceRequestPhotos(this.SelectedAppointments.service_request.id);
		}


		fetchServiceRequestPhotos(serviceRequestId: number) {
			const vm = this;

			vm.getServiceRequestPhotos(serviceRequestId)
				.then((response) => {
					vm.serviceRequestPhotos = response.data;
				});
		}

		deleteRecommendation(pkgId: number): ng.IHttpPromise<Package> {
			return this.$http.delete(`${this.Constants.apiUrl}recommendation/${pkgId}`);
		}

		restoreRecommendation(pkgId: number): ng.IHttpPromise<Package> {
			return this.$http.put(`${this.Constants.apiUrl}recommendation/${pkgId}/restore`, {});
		}

		getServiceRequestPhotos(serviceRequestId: number): ng.IHttpPromise<ServiceRequestPhoto[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/image`)
		}

		getServiceRequestPhotosByAddress(addressId: number, params?: object): ng.IHttpPromise<ServiceRequest[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest?service_address=${addressId}&show_images=true`, {
				params: params || {},
			});
		}

		getServiceRequestHistoryByAddress(addressId: number, params: object): ng.IHttpPromise<ServiceRequest[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest?service_address=${addressId}`, {
				params: params || {},
			});
		}

		getServiceRequestRecommendationsByAddress(addressId: number, params?: object): ng.IHttpPromise<ServiceRequest[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest?service_address=${addressId}&show_recommendations=true&has_recommendations=true`, {
				params: params || {},
			});
		}

		getServiceRequest(serviceRequestId: number): ng.IHttpPromise<ServiceRequest> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}`);
		}

		getInvoice(invoiceId: number): ng.IHttpPromise<Invoice> {
			return this.$http.get(`${this.Constants.apiUrl}invoice/${invoiceId}`);
		}

		getInvoiceHtml(invoiceId: number): ng.IHttpPromise<string> {
			return this.$http.get(`${this.Constants.apiUrl}invoice/${invoiceId}.html`);
		}

		getRecommendationHtml(recId: number): ng.IHttpPromise<string> {
			return this.$http.get(`${this.Constants.apiUrl}recommendationtoken/${recId}.html`);
		}

		getRecommendationsByServiceRequest(serviceRequestId: number, params?: object): ng.IHttpPromise<Package[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/recommendation`, {
				params: params || {}
			});
		}

		convertRecommendationToWorkOrder(selectedAppointmentServiceRequest: App.Appointments.ServiceRequest, recommendationId: number): ng.IHttpPromise<Package[]> {
			return this.$http.post(`${this.Constants.apiUrl}recommendation/${recommendationId}/package`, {
				service_request: selectedAppointmentServiceRequest
			});
		}

		emailRecommendations(
			serviceRequestId: number,
			recommendations: number[],
			email: string,
			emailNote?: string,
			allowNonRec: boolean = false
		): ng.IHttpPromise<any> {
			let params: {[key: string]: any} = {
				ids: recommendations,
				email: email,
				allowNonRec: allowNonRec,
			};

			if (emailNote) {
				params['note'] = emailNote;
			}

			return this.$http.post(`${this.Constants.apiUrl}recommendation/email`, params);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants, SelectedAppointment: SelectedAppointment) => {
				return new HistoryService($http, Constants, SelectedAppointment);
			};

			instance.$inject = ['$http', 'Constants', 'SelectedAppointment'];

			return instance;
		}
	}
}